import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "disabled", "loading"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_loader = _resolveComponent("bs-loader")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["bs-button", {
            'bs-button--gray': _ctx.color === 'gray',
            'bs-button--royal-blue': _ctx.color === 'royal-blue',
            'bs-button--red': _ctx.color === 'red',
            'bs-button--small': _ctx.size === 'small',
            'bs-button--medium': _ctx.size === 'medium',
            'bs-button--big': _ctx.size === 'big'
        }]),
    type: _ctx.type,
    disabled: _ctx.disabled,
    loading: _ctx.loading,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_bs_loader, {
          key: 0,
          color: "currentColor"
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}